import axios from "axios";

function them(nhanVien){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/nhanvien/them",nhanVien);
};
function getAll(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/personal/nhanvien/getall");
};
function capNhat(nhanVien){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/nhanvien/capnhat",nhanVien);
};
function xoa(ids){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/nhanvien/xoa",ids);
};

const NhanVienPersonalService={
  them,
  getAll,
  capNhat,
  xoa

};
export default NhanVienPersonalService;
